export const vertexShader = `
precision highp float;
attribute float aIndex;attribute float aSeed;attribute float aTone;attribute float aDetail;
uniform sampler2D uMorph;uniform float uWeights[13];uniform vec3 uAtlas;
uniform float uTime,uMotion,uAssembly,uDpr,uScale,uSpeaking,uDevicePointSize;
uniform vec3 uFocus;uniform float uFocusStrength;
varying float vLight,vAlpha,vAttention,vTone;varying vec3 vNormal;varying float vDepth;
void main(){
 vec3 p=position;
 float col=mod(aIndex,uAtlas.x),row=floor(aIndex/uAtlas.x);
 for(int j=0;j<13;j++){vec2 uv=vec2((col+.5)/uAtlas.x,(row+float(j)*uAtlas.z+.5)/uAtlas.y);p+=texture2D(uMorph,uv).xyz*uWeights[j];}
 // All frequencies stop at motion=0, including shimmer. No random respawns.
 float t=uTime*.65*uMotion;
 vec3 n=normalize(normal);
 vec3 rawFlow=vec3(
  sin(p.y*3.8+t+aSeed*17.)+.35*sin(t*1.7+p.z*5.+aSeed*31.),
  sin(p.z*3.5-t*.7+aSeed*23.)+.3*cos(t*1.3+p.x*4.+aSeed*13.),
  cos(p.x*4.+t*.8+aSeed*11.)+.3*sin(t*1.6+p.y*5.+aSeed*37.)
 );
 vec3 tangentFlow=rawFlow-n*dot(rawFlow,n);
 float moving=step(.60,aSeed);
 float floating=step(.89,aSeed);
 vec3 towards=uFocus-p;
 float attention=exp(-dot(towards,towards)/1.25)*uFocusStrength;
 vec3 tangentPull=towards-n*dot(towards,n);
 tangentPull/=max(length(tangentPull),.35);
 // The majority retains its surface anchor. A small outer layer rises and
 // returns on staggered, smooth cycles; facial highlights retain more detail.
 // Anatomical protection is independent of colour: dark pupils and brows
 // need the same stability as bright lids and lips.
 float detailProtection=1.-clamp(aDetail,0.,1.)*.90;
 float cycle=.5-.5*cos(t*(.8+aSeed*.55)+aSeed*61.);
 float lift=floating*pow(cycle,1.6)*(.16+.26*aSeed);
 float travel=(.048+.032*sin(t*3.2+aSeed*43.))*attention;
 p+=tangentFlow*uMotion*mix(.003,.042,moving)*detailProtection;
 p+=tangentPull*travel*moving*uMotion*detailProtection;
 p+=n*(.007+uMotion*(moving*(.016+.013*sin(t*1.8+aSeed*31.))+lift)*detailProtection);
 vAttention=attention*moving*uMotion;vTone=aTone;
 vec3 spread=vec3(sin(aSeed*91.),cos(aSeed*63.),sin(aSeed*37.))*1.8;
 p=mix(p+spread,p,uAssembly);
 vec4 mv=modelViewMatrix*vec4(p,1.);gl_Position=projectionMatrix*mv;
 gl_PointSize=clamp((1.9+aSeed*.85+floating*cycle*.4)*uDpr*uScale*uDevicePointSize*6./(-mv.z),.85,5.);
 vec3 nn=normalize(normalMatrix*normal);vNormal=nn;vDepth=clamp((-mv.z-4.)/5.,0.,1.);
 float key=max(0.,dot(nn,normalize(vec3(-.45,.7,1.))));
 float facing=max(0.,nn.z);
 vLight=(.16+pow(key,1.7)*.72+pow(1.-facing,2.)*.18)*aTone*(1.+sin(t+aSeed*28.)*.065)*(1.+uSpeaking*.1)+vAttention*.17+floating*cycle*.12;
 vAlpha=smoothstep(-1.58,-1.15,p.y)*(.62+aSeed*.28)*(1.-floating*cycle*.25)*uAssembly;
}`;
export const fragmentShader = `
precision highp float;
uniform vec3 uColor,uHighlight;uniform float uBrightness,uDebug;
varying float vLight,vAlpha,vAttention,vTone;varying vec3 vNormal;varying float vDepth;
void main(){float r=length(gl_PointCoord-.5)*2.;if(r>1.)discard;float edge=1.-smoothstep(.35,1.,r);vec3 c=mix(uColor,uHighlight,clamp(vLight*.8,0.,1.))*uBrightness;c*=mix(.28,1.,smoothstep(.12,.70,vTone))*clamp(.34+vLight*.9,.34,1.);if(uDebug>.5)c=uDebug<1.5?normalize(vNormal)*.5+.5:vec3(1.-vDepth);gl_FragColor=vec4(c,edge*vAlpha);
 #include <colorspace_fragment>
}
`;
export const ambientVertex = `
precision highp float;
attribute float aSeed;
uniform float uTime,uMotion,uDpr,uScale,uFocusStrength,uAssembly;
uniform vec3 uFocus;varying float vAlpha;
void main(){
 float t=uTime*.65*uMotion;
 // Independent speeds and directions avoid a rigid orbiting halo.
 float angle=t*(.055+.10*aSeed)*mix(-1.,1.,step(.5,aSeed));
 float cs=cos(angle),sn=sin(angle);
 vec3 p=vec3(position.x*cs-position.z*sn,position.y,position.x*sn+position.z*cs);
 vec3 drift=vec3(
  sin(t*.72+aSeed*17.)+.35*cos(t*1.1+aSeed*39.),
  cos(t*.53+aSeed*9.)+.35*sin(t*.87+aSeed*29.),
  sin(t*.61+aSeed*23.)+.35*cos(t*.91+aSeed*43.)
 );
 p+=drift*(.13+.11*aSeed)*uMotion;
 p+=normalize(position)*sin(t*.46+aSeed*53.)*.055*uMotion;
 vec3 towards=uFocus-p;float distanceToFocus=length(towards);
 p+=towards/max(distanceToFocus,1.)*uFocusStrength*uMotion*(.16+.08*sin(t+aSeed*31.));
 vec4 mv=modelViewMatrix*vec4(p,1.);gl_Position=projectionMatrix*mv;
 gl_PointSize=clamp((1.9+aSeed*1.65)*uDpr*uScale*6./(-mv.z),1.1,4.6);
 // Slow breathing in opacity, never hard blinking or teleporting.
 vAlpha=(.40+aSeed*.28)*(.86+.14*sin(t*.55+aSeed*47.))*uAssembly;
}`;
export const ambientFragment = `
uniform vec3 uColor;uniform float uBrightness;varying float vAlpha;
void main(){float d=length(gl_PointCoord-.5)*2.;if(d>1.)discard;gl_FragColor=vec4(uColor*uBrightness,(1.-smoothstep(.22,1.,d))*vAlpha);
 #include <colorspace_fragment>
}`;

